export default __webpack_public_path__ + "static/media/milestone 2000.aac9b11e.svg";